import React from 'react';
import { FileUploader } from '../shared/file-uploader';
import getLayerUploadParams from './upload-url';

interface KMLProps {
  startUpload: boolean;
  onUploadBegin: () => void;
  onComplete: () => void;
  onError: () => void;
  maxFiles: number;
}

interface Props {
  isNew: boolean;
  fileUploaderProps: KMLProps;
  setLayerFile: (key: string, name: string) => void;
  apiToken?: string;
}

const KMLLayer: React.FC<Props> = ({
  isNew, fileUploaderProps, setLayerFile, apiToken,
}: Props) => {
  const getPresignedUrl = ({ file }) => getLayerUploadParams({ file, setLayerFile, apiToken });

  if (isNew) {
    return (
      <FileUploader
        {...fileUploaderProps}
        onUploadParams={getPresignedUrl}
        acceptedFileTypes=".kml,.kmz"
        acceptedFilesName="KML/KMZ"
      />
    );
  }

  return null;
};

export default KMLLayer;
